export default {
  "route": {
    "title": "情報配信システム",
    "home": "ホーム",
    "terminal": "端末",
    "program": "プログラム",
    "h5program": "プログラム",
    "my": "マイ",
    "remote_control": "リモートコントロール",
    "task_details": "タスク詳細",
    "add_task": "タスク追加",
    "program_list": "プログラムリスト",
    "terminal_info": "端末情報",
    "add_resolution": "解像度追加",
    "add_program": "プログラム追加",
    "material_management": "素材管理",
    "create_program": "プログラム作成",
    "login": "ログイン",
    "reset_password": "パスワードリセット",
    "change_password": "パスワード変更",
    "preview": "プレビュー"
  },
  append_field:{
    "input_code": "認証コードを入力してください",
    "code_error": "認証コードエラー",
    "fill_code": "認証コードを入力してください",
    "dOut": "3D回転アウト",
    "dIn": "3D回転イン",
    "dxiao": "3Dフレーム効果",
    "selectImage": "画像を選択してください",
    "onlySelectOneImage": "画像は1枚のみ選択できます",
    "imageFormatError": "画像形式エラー",
    "cancel": "キャンセル",
    "selectedNumber": "選択済み",
    "confirm": "確認",
    "loadinga": "読み込み中...",
    "loadingb": "読み込み中",
    "uploading": "アップロード中",
    "selectStartDates": "開始日を選択してください",
    "selectEndDates": "終了日を選択してください",
    "createTask": "新しいタスクを作成",
    "selectPrograms": "プログラムを選択",
    "createPrograms": "新プログラム作成",
    "editTask": "タスクを編集",
    "fillTaskName": "名前を入力してください",
    "selectTaskGroup": "タスクグループを選択してください",
    "selectProgram": "プログラムを選択してください",
    "selected": "選択済み",
    "programs": "個のプログラム",
    "selectDevice": "デバイスを選択してください",
    "sendTaskSuccess": "タスク送信成功",
    "taskName": "名前",
    "playMode": "再生モード",
    "replaceMode": "置換モード",
    "appendMode": "追加モード",
    'apotpatterns': '挿入モード',
    "dateRange": "再生日",
    "timeRange": "再生時間",
    "taskPeriod": "指定曜日",
    "mon": "月",
    "tue": "火",
    "wed": "水",
    "thu": "木",
    "fri": "金",
    "sat": "土",
    "sun": "日",
    "back": "戻る",
    "programList": "プログラムリスト",
    "deviceList": "デバイスリスト",
    "enterContent": "内容を入力してください",
    "taskGroup": "タスクグループ",
    "selectStartDate": "開始日を選択してください",
    "selectEndDate": "終了日を選択してください",
    "selectStartTime": "開始時間を選択してください",
    "selectEndTime": "終了時間を選択してください",
    "addTask": "タスクを追加",
    "topLeft": "左上",
    "topCenter": "中央上",
    "topRight": "右上",
    "leftCenter": "左中央",
    "center": "中央",
    "rightCenter": "右中央",
    "bottomLeft": "左下",
    "bottomCenter": "中央下",
    "bottomRight": "右下",
    "enterText": "テキストを入力してください",
    "fontColor": "フォントカラー",
    "bgColor": "背景色",
    "scrollDirection": "スクロール方向",
    "scrollSpeed": "スクロール速度",
    "fontSize": "フォントサイズ",
    "alignment": "整列",
    "subtitle": "字幕",
    "enterURL": "URLを入力してください",
    "webPage": "ウェブ",
    "enterMediaURL": "ストリーミングアドレスを入力してください",
    "media": "ストリーム",
    "selectVideo": "ビデオを選択してください",
    unsupportedFormat: 'サポートされていないファイル形式です。詳細なサポート形式については、「マイ - システムヘルプ」をご覧ください。',
    "cancelAllSelections": "新しいファイルをアップロードする前に、選択したすべての素材をキャンセルしてください",
    "fileName": "ファイル名",
    "fileSize": "ファイルサイズ",
    "uploadProgress": "アップロード進行",
    "cancelUpload": "アップロードをキャンセル",
    "cancelAllUploads": "すべてのアップロードをキャンセル",
    "leftToRights": "左から右へ",
    "rightToLefts": "右から左へ",
    "bottomToTops": "下から上へ",
    "static": "静止",
    "slow": "遅い",
    "medium": "中速",
    "fast": "速い",
    "colorValue": "カラー値",
    "defaultEffect": "デフォルト効果",
    "rightToLeft": "右から左へ",
    "leftToRight": "左から右へ",
    "topToBottom": "上から下へ",
    "bottomToTop": "下から上へ",
    "accordionSqueeze": "アコーディオン",
    "zoomInFade": "ズームイン",
    "zoomOutFade": "ズームアウト",
    "depthOfField": "被写界深度",
    "leftRightRotate": "左右回転",
    "upDownRotate": "上下回転",
    "counterclockwiseRotate": "反時計回り",
    "clockwiseRotate": "時計回り",
    "upDownZoom": "上下ズーム",
    "scaleFade": "スケールフェード",
    "zoomInDisappearing": "ズームイン",
    "transparentFade": "透明フェード",
    "gradientScale": "グラデーション",
    "deleteMaterial": "素材を削除",
    "confirmDeleteMaterial": "この素材を削除しますか？",
    "unreviewed": "未審査",
    "normal2": "通常",
    "violating": "違反",
    "suspectedViolating": "疑わしい違反",
    "delete": "削除",
    "selectMaterial": "素材を選択してください",
    "deleteProgramGroup": "プログラムグループを削除",
    "confirmDeleteGroup": "このグループを削除しますか？",
    "add": "追加",
    "toggle_effect": "効果切り替え",
    "toggle_time": "時間切り替え",
    "pub_toggle_time": "統一切り替え時間",
    "fullscreen": "全画面",
    "normal": "普通",
    "interactive": "インタラクティブ",
    "main_screen": "メイン画面",
    "sub_screen": "サブ画面",
    "dual_screen": "デュアルスクリーン",
    "sync_task": "タスクを同期",
    "normal_mode": "通常モード",
    "basic_info": "基本情報",
    "program_info": "プログラム情報",
    "task_name": "プログラム名",
    "task_type": "タスクタイプ",
    "pub_task": "通常タスク",
    "hu_task": "インタラクティブタスク",
    "no_data": "データなし",
    "no_msg": "メッセージなし",
    "program_name": "プログラム名",
    "program_resolution": "プログラム解像度",
    "program_type": "プログラムタイプ",
    "screen_category": "スクリーンカテゴリ",
    "edit_program": "プログラムを編集",
    "edit": "編集",
    "send": "送信",
    "create": "グループを作成",
    "reload": "リロード",
    "name": "名前",
    "create_task_z": "タスクグループを作成",
    "ps_push_name": "グループ名を入力してください",
    "device_list": "デバイスリスト",
    "delete_task_group": "タスクグループを削除",
    "confirm_delete_group": "このグループを削除しますか？",
    "delete_success": "削除成功",
    "name_cannot_be_empty": "名前は空にできません",
    "character_length_limit": "文字数は10文字以内でなければなりません",
    "create_task_success": "タスク作成成功",
    "create_task_failed": "作成失敗",
    "confirm_delete_task": "タスクを削除しますか？",
    "task_details": "タスク詳細",
    "download_success": "ダウンロード成功",
    "waiting_download": "ダウンロード待機中",
    "downloading": "ダウンロード中",
    "confirm_delete": "削除しますか？",
    "confirm_delete_all": "すべて削除しますか？",
    "confirm_delete_selected": "選択したものを削除しますか？",
    "no_data_to_clear": "クリアするデータがありません！",
    "refresh": "リフレ",
    "clear_all": "すべてクリア",
    "clear_completed": "完了クリア",
    "device_id": "デバイスID",
    "task_size": "タスクサイズ",
    "speed": "速度",
    "download_progress": "ダウンロード進行",
    "title": "タイトル",
    "volume": "音量",
    "deleteP": "プログラム削除",
    "con_P": "このプログラムを削除しますか？",
    "clear": "クリア",
    "download_status": "ダウンロード状況",
    "height_width_cannot_be_empty": "高さ/幅は空にできません",
    "add_success": "追加成功",
    "enter_number_between_300_to_8000": "300~8000の間の数字を入力してください",
    "width": "幅",
    "enter_width": "幅を入力してください",
    "height": "高さ",
    "enter_height": "高さを入力してください",
    "confirm_leave_page": "このページを離れますか？",
    "add_content_to_control": "コントロールにコンテンツを追加してください",
    "add_control": "コントロールを追加してください",
    "save_success": "保存成功",
    "save": "保存",
    "create_program": "プログラム作成",
    "guess": "あなたの推測",
    "modify": "修正",
    "text": "テキスト",
    "image": "画像",
    "background_image": "背景画像",
    "background_music": "背景音楽",
    "replace": "置き換え",
    "use_this_template": "このテンプレートを使用",
    "apply_template": "テンプレートを適用",
    "enter_program_name": "プログラム名を入力してください",
    "program_group": "プログラムグループ",
    "select_program_group": "プログラムグループを選択してください",
    "group_list": "グループリスト",
    "preview": "プレビュー",
    "my_apps": "マイアプリ",
    "template_center": "テンプレートセンター",
    "home": "ホーム",
    "source_of_visit": "訪問元",
    "online": "オンライン",
    "terminal_status": "状態",
    "memory_status": "メモリの状態",
    "login": "ログイン",
    "sms_verification": "SMS認証",
    "email_verification": "メール認証",
    "log_in": "ログイン",
    "enter_username": "アカウントを入力してください",
    "username_cannot_be_empty": "ユーザー名は空にできません",
    "password_cannot_be_empty": "パスワードは空にできません",
    "incorrect_phone_format_for_verification_code": "取得した認証コードの電話番号形式が間違っています。管理者に修正を依頼してください！",
    "incorrect_email_format_for_verification_code": "取得した認証コードのメール形式が間違っています。管理者に修正を依頼してください！",
    "incorrect_phone_or_email_format_for_verification_code": "取得した認証コードのメールまたは電話形式が間違っています。管理者に修正を依頼してください！",
    "reset_password": "パスワードをリセット",
    "remember_password": "パスワードを記憶する",
    "register": "アカウント登録",
    "current_version_4.1.6": "V4.1.8",
    "notification_about_network_security": "ネットワークセキュリティに関する通知",
    "got_it": "わかりました",
    "please_authenticate_for_account_safety": "アカウントの安全のために認証を行ってください",
    "enter_account": "アカウントを入力してください",
    "enter_password": "パスワードを入力してください",
    "verification_code": "認証コード",
    "none": "なし",
    "personal_center": "個人センター",
    "remote_control": "リモートコントロール",
    "refresh_success": "リフレッシュ成功！",
    "logout": "ログアウト",
    "confirm_logout": "ログアウトしますか？",
    "user_status": "ユーザーの状態",
    "customer_address": "顧客住所",
    "account_period": "アカウント期間",
    "device_control": "デバイスリモートコントロール",
    "clear_cache": "キャッシュをクリア",
    "exit": "終了",
    "terminal": "端末",
    "program": "プログラム",
    "material": "素材",
    "my": "私の",
    "display_type": "表示タイプ",
    "proportion": "比率",
    "resolution": "解像度",
    "screen_orientation": "画面の向き",
    "landscape": "横向き",
    "portrait": "縦向き",
    "add_resolution": "解像度を追加",
    "execute_formatting_when_focus_lost": "フォーカスを失ったときにフォーマットを実行",
    "select_resolution": "解像度を選択してください",
    "resolution_list": "解像度リスト",
    "confirm_delete_program": "プログラムを削除しますか？",
    "confirm_delete_this_program": "このプログラムを削除しますか？",
    "bound_tasks_exists_confirm_delete": "バインドされたタスクがあります。削除しますか？",
    "prompt": "プロンプト",
    "delete_failed": "削除失敗",
    "modification_time": "変更時間",
    "resolution_": "解像度",
    "associated_tasks": "関連タスク",
    "bound_task": "バインドされたタスク",
    "program_management": "プログラム管理",
    "task": "タスク",
    "progress": "進捗",
    "phone_number": "電話番号",
    "enter_phone_number": "電話番号を入力してください",
    "password": "パスワード",
    "confirm_password": "パスワード確認",
    "enter_password_again": "パスワードを再入力してください",
    "company_name": "会社名",
    "enter_company_name": "会社情報を入力してください",
    "address": "住所",
    "enter_address": "連絡先住所を入力してください",
    "username_not_exist": "ユーザー名が存在しません",
    "enter_new_password": "新しいパスワードを入力してください",
    "enter_new_password_again": "新しいパスワードを再度入力してください",
    "terminal_management": "端末管理",
    "delete_group": "グループ削除",
    "pel_select_group": "グループを選択してください",
    "enter_device_name": "デバイス名を入力してください",
    "delete_device": "デバイス削除",
    "confirm_delete_device": "このデバイスを削除しますか？",
    "terminal_information": "端末情報",
    "qr_code_error": "QRコードエラー",
    "device_not_supported": "デバイスがサポートされていません",
    "device_offline": "選択したデバイスはオンラインでなければコマンドを送信できません。再選択してください！",
    "more": "もっと",
    "device_access": "デバイスアクセス",
    "filter": "フィルタ",
    "all": "すべて",
    "offline": "オフライン",
    "device_name": "デバイス名",
    "device_number": "デバイス番号",
    "device_group": "デバイスグループ",
    "call_device_please_wait": "デバイスを呼び出しています。しばらくお待ちください...",
    "create_terminal_group": "新しいデバイスリストグループを作成",
    "enter_search_keyword": "検索キーワードを入力してください",
    "bind_device": "デバイスをバインド",
    "select_device_group": "デバイスグループを選択してください",
    "authorized": "承認済み",
    "unauthorized": "未承認",
    "adjust_volume": "音量調整",
    "reboot_device": "デバイス再起動",
    "wake_up": "起動",
    "sleep": "スリープ",
    "shutdown": "シャットダウン",
    "clean_up_timing_on_off": "クリーンアップタイミング",
    "clean_up_disk": "ディスククリーンアップ",
    "clean_up_task": "タスククリーンアップ",
    "send_command": "コマンドを送信",
    "confirm2": "送信しますか？",
    "terminal_operation": "端末操作",
    "bind_task": "タスク情報",
    "remote_command": "リモートコマンド",
    "remote_monitor": "リモートモニタリング",
    "adding_one_will_override_the_previous": "1件のみ追加可能で、前の記録を上書きします",
    "screenshot_in_progress_please_wait": "スクリーンショットを取得中です。しばらくお待ちください",
    "schedule_on_off": "定期的な電源のオン/オフ",
    "shutdown_time": "シャットダウン",
    "startup_time": "起動時間",
    "volume_setting": "音量設定",
    "edit_device_name": "デバイス名を編集",
    "please_select_time": "時間を選択してください",
    "device_not_online_please_retry": "デバイスがオンラインではありません。再試行してください",
    "sent_successfully": "送信成功",
    "version": "V4.1.8",
    "texta": "テキスト",
    "userName": "アカウント",
    "email": "メール",
    "device_memory": "デバイスメモリ",
    "device": "デバイス",
    "device_mac": "デバイスMAC",
    "screen_count": "画面数",
    "device_location": "デバイス位置",
    "is_authorized": "承認されているか",
    "remark": "備考",
    "device_ip": "デバイスIP",
    "system_version": "システムバージョン",
    "playback_date": "再生日",
    "playback_period": "再生期間",
    "retrieve_again": "再取得",
    "please_enter_password": "8桁以上の数字、文字、特殊文字[@#$%^&+=]を含むパスワードを入力してください！",
    "passwords_do_not_match": "入力したパスワードが一致しません",
    "enter_new_password2": "新しいパスワードを入力",
    "current_password_too_simple": "現在のパスワードは簡単すぎます。アカウントの安全のため、8桁以上の数字、文字、特殊文字[@#$%^&+=]を含むパスワードに変更してください",
    "creation_time": "作成時間",
    "login2": "ログイン",
    "welcome": "ログインへようこそ",
    "expired_login": "認証が期限切れです。再ログインしてください。",
    "control": "リモートコントロール",
    "add_task": "タスクを追加",
    "program_list": "プログラムリスト",
    "terminal_info": "端末情報",
    "add_program": "プログラムを追加",
    "material_management": "素材管理",
    "change_password": "パスワード変更",
    "enter_text_content": "テキスト内容を入力してください",
    "hit_the_wall_on_back": "戻ると壁があります",
    "last_ceremony": "最後の儀式",
    "already_top_level": "すでに最上位です",
    "already_last_one": "すでに最後です",
    "white_fox": "白い狐",
    "control_img": "画像",
    "control_video": "ビデオ",
    "control_streaming": "ストリーム",
    "control_webPage": "ウェブ",
    "control_subtitle": "字幕",
    "control_HDMI": "HDMI",
    "control_addbackground": "背景を追加",
    "Up": "アップロード",
    "onlyOne": "コントロールは1つだけ追加できます",
    "clearBg": "背景をクリア",
    "get_code": "まず認証コードを入力してください",
    "del_Null_Program": "リスト内の内容が空のプログラムをクリアしてもよろしいですか？",
    "please_select_date": "少なくとも1つの日付を選択してください",
    "last_size": "残りスペース",
    "shutdown_tips": "シャットダウン後はリモートで起動できません",
    "last_size_upload": "再選択してください。",
    "end_date_earlier_than_start_date": "終了日が開始日より早くてはいけません",
    "account_type": "ユーザータイプ",
    "user_type": "一般ユーザー",
    "role_type": "役割",
    "super_administrator": "スーパ管理者",
    "term_info_empty": "端末情報が空です",
    "select_terminal_prompt": "右上のリストボタンをクリックして端末を選択してください",
    "select": "選択",
    "data_empty": "データが空です！",
    "content_review": "コンテンツレビュー",
    "start_date": "開始日",
    "end_date": "終了日",
    "start_time": "開始時間",
    "end_time": "終了時間",
    "select_all": "全選択",
    "select_group": "グループを選択",
    "review": "レビュ",
    "material_type": "素材の種類",
    "audio": "オーディオ",
    "document": "文書",
    "material_status": "素材の状態",
    "material_review": "素材レビュー",
    "current_selection_requires_review": "現在選択している素材は、レビューが必要ですか？",
    "invCode": "招待コード",
    "tip_invitation_empty": "招待コードを入力してください",
    "enter_userName": "ユーザーアカウントを入力してください",
    "enter_email": "メールアドレスを入力してください",
    "file_less_38": "ファイルは38KB未満でなければなりません",
    "viewError": "このファイルはプレビューをサポートしていません",
    "user": "個人情報",
    "phone_number_too_short": "電話番号の長さは9桁以上である必要があります",
    "oneImage": "背景画像はすでに存在します。再アップロードするには、まず削除してください",
    "del_title": "削除確認",
    "del_message": "このコントロールを削除しますか？",
    "close": "閉じる",
    "exit_group_name": "グループ名を編集",
    "group_management": "グループ管理",
    "language": "言語切替",
    "mixture": "混合放送",
    "date": "日付",
    "weeks": "週",
    "time": "時間",
    "new_password": "新しいパスワード",
    "enter_invCode": "ご注意：招待コードは上位管理者にお問い合わせください",
    "msg_password": "ご注意：8桁以上の数字、文字、特殊文字[@#$%^&+=]を含むパスワードを入力してください！",
    "oneDoc": "文書はすでに存在します。再アップロードするには、まず削除してください",
    "Sunday": "日曜日",
    "Monday": "月曜日",
    "Tuesday": "火曜日",
    "Wednesday": "水曜日",
    "Thursday": "木曜日",
    "Friday": "金曜日",
    "Saturday": "土曜日",
    "input_error": "すべてのフィールドは空にできません",
    video_tutorial:'資料',
    "view": "オンライン視聴",
    "selectDeviceOne": "このコマンドは1台のデバイスのみ選択できます",
    "select_device_list": "選択したデバイスリスト",
    "small_size": "小",
    "medium_size": "中",
    "large_size": "大",
    device_info:'デバイス情報',
    "notification": "通知",
    "notif_title": "通知内容",
    "notif_msg": "2024年11月5日より、ETVサービスセンターは1年以上保存された素材を削除します。重要な素材は事前にバックアップしてください。ご理解とご協力に感謝します。",
    reduce:'縮小',
    bound_material: 'バインド素材',
    tip_material: 'バインドされたプログラムの素材は削除できません。まず素材のバインドを解除してください。',
    boundpo: 'バインドされたプログラム',
    bind_progron: 'この素材はプログラムにバインドされているため、削除できません。',
    index: 'インデックス',
    source: '出所',
    getUploadSet_tip: '素材のアップロード禁止の取得に失敗しました。',
    getUploadstartTime_tip: '現在の時間は素材のアップロードが禁止されています。禁止されていない時間にアップロードしてください。',
    getUploadendTim: '素材のアップロードが禁止されています',
    "download": "ダウンロード",
    program_review: 'プログラムレビュー',
    pass: '合格',
    not_passed_or_not_reviewed: '不合格または未審査',
    play_mode: '再生モード',
    review_status: 'レビュー状態',
    reject: '拒否',
    review_content: 'レビュー内容',
    enter_review_content: 'レビュー内容を入力してください',
    device_quantity: "デバイス数",
    system_help: 'システムヘルプ',
    updateInfo: '更新情報',
    Formatspecification: '形式の説明',
    fileFormat: 'ファイル形式',
    imgFormat: '画像形式',
    audioFormat: 'オーディオ形式',
    videoFormat: 'ビデオ形式',
    updated: '更新日',
    details: '1：マイ - システムヘルプメニューを追加<br>2：新しいアップロード素材タイプ、Tencentクラウドアップロード、PC設定との同期を追加<br>3：素材および番組素材表示機能を最適化',
    "nameLengthLimit": "名前の長さを50文字以内に制限してください。",
    "customer_title": "アカウント照会",
    "authorized_devices": "承認デバイス台数",
    "enable": "有効",
    "disable": "無効",
    "expired": "アカウント期限切れ",
    "valid_date": "有効期限",
    "valid_date_placeholder": "有効期限を入力",
    "capacity_rule": "サーバー容量は100の倍数でなければなりません",
    "capacity_label": "サーバー容量（MB）",
    "download_speed": "ダウンロード速度制限",
    "submit_btn": "送信",
    "sub_accounts":"サブアカウントのみ編集可能",
    plan_mode: '計画モード',
    default_mode: 'デフォルトモード',

  }
}